export const INTERMEZZO = new Uint8Array([
  0x44,
  0x00,
  0x9f,
  0xe5,
  0x01,
  0x11,
  0xa0,
  0xe3,
  0x40,
  0x20,
  0x9f,
  0xe5,
  0x00,
  0x20,
  0x42,
  0xe0,
  0x08,
  0x00,
  0x00,
  0xeb,
  0x01,
  0x01,
  0xa0,
  0xe3,
  0x10,
  0xff,
  0x2f,
  0xe1,
  0x00,
  0x00,
  0xa0,
  0xe1,
  0x2c,
  0x00,
  0x9f,
  0xe5,
  0x2c,
  0x10,
  0x9f,
  0xe5,
  0x02,
  0x28,
  0xa0,
  0xe3,
  0x01,
  0x00,
  0x00,
  0xeb,
  0x20,
  0x00,
  0x9f,
  0xe5,
  0x10,
  0xff,
  0x2f,
  0xe1,
  0x04,
  0x30,
  0x90,
  0xe4,
  0x04,
  0x30,
  0x81,
  0xe4,
  0x04,
  0x20,
  0x52,
  0xe2,
  0xfb,
  0xff,
  0xff,
  0x1a,
  0x1e,
  0xff,
  0x2f,
  0xe1,
  0x20,
  0xf0,
  0x01,
  0x40,
  0x5c,
  0xf0,
  0x01,
  0x40,
  0x00,
  0x00,
  0x02,
  0x40,
  0x00,
  0x00,
  0x01,
  0x40
]);
